// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"F5-z"};